module.exports = __webpack_public_path__ + "img/article-2.a6559241.jpg";